module.exports = __webpack_public_path__ + "assets/img/title-ca519c04.png";